import React, { useEffect, useState } from 'react';
import { Button, Form, Input, Select, DatePicker } from 'components/shared/FormComponent';
import { useLocation, useNavigate } from 'react-router-dom';
import {message, Spin} from 'components/shared/AntComponent';
import { useDispatch, useSelector } from 'react-redux';
import { getCandidateProjectLists } from 'services/store/actions/candidateAction';
import { LoadingOutlined } from 'components/shared/AntIcons';
import { getAllCandidates, getBatchInfo, getProjectBatchInfo, saveBatchDetails, saveProjectMasterDetails } from 'services/store/actions/masterDataAction';
import dayjs from 'dayjs';

const { TextArea } = Input;

const AddBatch: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const { internListInfo, loading3, prjListInfo, loading4 } = useSelector((state: any) => state.candidate);
    const { success1, error1, loading1, success3, error3, loading3: prjLoading, loading4: batchLoading, allCandidInfo, loading5, indvBatchInfo, indvPrjBtchInfo, loading6 } = useSelector((state: any) => state.master);
    const [showSuccessmsg, setShowSuccessmsg] = useState(false);
    const successmsg = showSuccessmsg ? success1 : false;
    const [showErrormsg, setShowErrormsg] = useState(false);
    const errormsg = showErrormsg ? error1 : false;
    const [showSuccessmsg1, setShowSuccessmsg1] = useState(false);
    const successmsg1 = showSuccessmsg1 ? success3 : false;
    const [showErrormsg1, setShowErrormsg1] = useState(false);
    const errormsg1 = showErrormsg1 ? error3 : false;
    const [startDate, setStartDate]: any = useState(null);

    const options = !loading5
        ? allCandidInfo?.data
            ?.filter((item: any) => !item.batch_associated_flag || (item.batch_associated_flag && item.batch_id == location.state.id)) // ✅ First filter out unwanted items
            .map((item: any) => ({
                label: `${item.fname} ${item.mname} ${item.lname}`,
                value: item.id?.toString(),
            })) || []
        : [];

    const prjOptions = !loading4
        ? prjListInfo?.AccountDetail
            ?.filter((item: any) => !item.batch_associated_flag || (item.batch_associated_flag && item.project_id == location.state.id)) // ✅ First filter out unwanted items
            .map((item: any) => ({
                label: `${item.fname} ${item.mname} ${item.lname}`,
                value: item.id?.toString(),
            })) || []
        : [];

    const goToPreviousScreen = () => {
        if (location?.state?.type === '1') {
            navigate('/batch');
        } else {
            navigate('/project');
        }
    };

    function getBatch() {
        dispatch(getBatchInfo(location.state.id) as any);
    }

    function getProjectInformation() {
        dispatch(getProjectBatchInfo(location.state.id) as any);
    }

    const submitBatchForm = (value: any) => {
        if (location.state.type === '1') {
            const inputJson = {
                batch_id: location?.state?.id || 0,
                batch_name: value.batchName || '',
                description: value.description || '',
                batch_st_date: value['startDate']?.format('YYYY-MM-DD') || '',
                batch_en_date: value['endDate']?.format('YYYY-MM-DD') || null,
                mode_of_applied: value.appliedMode || '',
                associated_candidates: value.associatedCandidates?.toString() || null,
                associated_trainers: value?.associateTrainer || '',
                feedback: value?.feedback || '',
                batch_amount: Number(value.amount) || 0,
                status: value.status || 'Yet to Start',
            };
            dispatch(saveBatchDetails(inputJson) as any);
            setShowErrormsg(true);
            setShowSuccessmsg(true);
        } else {
            const inputJson1 = {
                project_id: location?.state?.id || 0,
                project_name: value.batchName || '',
                description: value.description || '',
                project_st_date: value['startDate']?.format('YYYY-MM-DD') || '',
                project_en_date: value['endDate']?.format('YYYY-MM-DD') || null,
                mode_of_applied: value.appliedMode || '',
                associated_candidates: value.associatedCandidates?.toString() || null,
                project_lead: value?.associateTrainer || '',
                associated_employees: '',
                feedback: value?.feedback || '',
                project_amount: Number(value.amount) || 0,
                status: value.status || 'Yet to Start',
            };
            dispatch(saveProjectMasterDetails(inputJson1) as any);
            setShowErrormsg1(true);
            setShowSuccessmsg1(true);
        }

    };

    const validateAmount = (_: any, value: any) => {
        const numericValue = Number(value); // Convert value to a number

        if (isNaN(numericValue)) {
            return Promise.reject(new Error('Enter a valid number'));
        }
        if (numericValue <= 0) {
            return Promise.reject(new Error('Amount must be greater than zero'));
        }
        return Promise.resolve();
    };
    const modeOptions = [
        { value: 'offline', label: 'Offline' },
        { value: 'online', label: 'Online' },
    ];
    const statusOptions = [
        {
            label: 'Yet to start',
            value: 'Yet to Start',
        },
        {
            label: 'Ongoing',
            value: 'Ongoing',
        },
        {
            label: 'Completed',
            value: 'Completed',
        },
    ];

    function getCandidate() {
        dispatch(getAllCandidates() as any);
    }

    function getProject(page: number, size: number, search: string) {
        const inputJson = {
            Input: {
                status: 'Active',
                candidate_type: 3,
                batch_id: 0,
                project_id: 0,
                "batch_associated_flag": false,
            },
            DataFinder: {
                pagesize: 10000,
                currentpage: 1,
                sortbycolumn: '',
                sortby: 'asc',
                searchdata: search || '',
            }
        };
        dispatch(getCandidateProjectLists(inputJson) as any);
    }

    const loadData = () => {
        if (location.state.id !== 0) {
            if (location.state.type === '1') {
                form.setFieldsValue({
                    batchName: indvBatchInfo?.data?.batch_name || '',
                    description: indvBatchInfo?.data?.description || '',
                    startDate: indvBatchInfo?.data ? dayjs(indvBatchInfo?.data?.batch_st_date) : '',
                    endDate: indvBatchInfo?.data ? dayjs(indvBatchInfo?.data?.batch_en_date) : '',
                    amount: indvBatchInfo?.data?.batch_amount || '',
                    status: indvBatchInfo?.data?.status || '',
                    appliedMode: indvBatchInfo?.data?.mode_of_applied || '',
                    associatedCandidates: indvBatchInfo?.data ? indvBatchInfo?.data?.associated_candidates?.split(',') : [],
                    associateTrainer: indvBatchInfo?.data?.associated_trainers || '',
                    feedback: indvBatchInfo?.data?.feedback || '',
                });
                setStartDate(indvBatchInfo?.data ? indvBatchInfo?.data?.batch_st_date : null);
            } else {
                form.setFieldsValue({
                    batchName: indvPrjBtchInfo?.data?.project_name || '',
                    description: indvPrjBtchInfo?.data?.description || '',
                    startDate: indvPrjBtchInfo?.data ? dayjs(indvPrjBtchInfo?.data?.project_st_date) : '',
                    endDate: indvPrjBtchInfo?.data ? dayjs(indvPrjBtchInfo?.data?.project_en_date) : '',
                    amount: indvPrjBtchInfo?.data?.project_amount || '',
                    status: indvPrjBtchInfo?.data?.status || '',
                    appliedMode: indvPrjBtchInfo?.data?.mode_of_applied || '',
                    associatedCandidates: indvPrjBtchInfo?.data ? indvPrjBtchInfo?.data?.associated_candidates?.split(',') : [],
                    associateTrainer: indvPrjBtchInfo?.data?.project_lead || '',
                    feedback: indvPrjBtchInfo?.data?.feedback || '',
                });
                setStartDate(indvPrjBtchInfo?.data ? indvPrjBtchInfo?.data?.project_st_date : null);
            }
        } else {
            form.resetFields();
            setStartDate(null);
        }

    };

    useEffect(() => {
        if (location?.state?.id !== 0) {
            if (location.state.type == '1') {
                getBatch();
            } else {
                getProjectInformation();
            }

        } else {
            form.resetFields();
            setStartDate(null);
        }
    }, [location?.state?.id]);

    useEffect(() => {
        if (indvPrjBtchInfo?.data || indvBatchInfo?.data) {
            loadData();
        }

    }, [indvBatchInfo, indvPrjBtchInfo])

    useEffect(() => {
        // if (location.state?.id !== 0) {
        if (location.state.type === '1') {
            getCandidate();
        } else {
            getProject(1, 1000000, '');
        }
        // }
    }, [location.state]);

    useEffect(() => {
        if (successmsg) {
            if (location?.state?.type === '1') {
                message.success(`Batch ${location?.state?.id === 0 ? 'created' : 'updated'} successfully`);
                navigate('/batch');
            }
            if (location?.state?.id !== 0) {
                goToPreviousScreen();
            }
            setShowSuccessmsg(false);
            form.resetFields();
            setStartDate(null);
        }
        if (errormsg) {
            if (error1?.data) {
                message.error(error1?.data);
            } else {
                message.error(`Batch couldn't be ${location?.state?.id === 0 ? 'created' : 'updated'}`);
            }
            setShowErrormsg(false);
        }
    }, [successmsg, errormsg]);
    useEffect(() => {
        if (successmsg1) {
            message.success(`Project batch ${location?.state?.id === 0 ? 'created' : 'updated'} successfully`);
            navigate('/project');
            if (location?.state?.id !== 0) {
                goToPreviousScreen();
            }
            setShowSuccessmsg1(false);
            form.resetFields();
            setStartDate(null);
        }
        if (errormsg1) {
            if (error3?.data) {
                message.error(error3?.data);
            } else {
                message.error(`Project batch couldn't be ${location?.state?.id === 0 ? 'created' : 'updated'}`);
            }
            setShowErrormsg1(false); // Ensure that `errormsg1` is reset
        }
    }, [successmsg1, errormsg1, location?.state?.id]);

    const disablePastDates = (current: dayjs.Dayjs | null) => {
        return startDate && current?.isBefore(startDate, 'day');
    };
    const onStartDateChange = (date: any | null) => {
        setStartDate(date);
        // if (endDate && date && date.isAfter(endDate)) {
        //   setEndDate(null); // Reset end date if it's after the start date
        // }
    };

    return (
        <div className="px-2">
            <div className="my-3 px-0">
                <div className="row m-0">
                    <h5 className="my-auto col text-start ps-0 text-secondary fw-bold">
                        {location?.state?.type === '1' ? (location.state?.id === 0 ? 'Create Batch' : 'Update Batch') : location.state?.id === 0 ? 'Create Project' : 'Update Project'}
                    </h5>
                    <div className="ms-auto col text-end my-auto pe-0">
                        <Button type="primary" className="col-auto ms-2 btn-back" onClick={goToPreviousScreen}>
                            Back
                        </Button>
                    </div>
                </div>
            </div>
            <Spin spinning={batchLoading || loading6}>
                <div className="bg-white px-2 py-3">
                    <Form form={form} layout="vertical" onFinish={submitBatchForm}>
                        <div className="row m-0">
                            <Form.Item
                                name="batchName"
                                className="col"
                                normalize={(value) =>
                                    value ? value.charAt(0).toUpperCase() + value.slice(1) : ''
                                }
                                label={location?.state?.type === '1' ? 'Batch Name' : 'Project Name'}
                                rules={[{ required: true, message: 'This field is required' }]}
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item name="startDate" className="col-md-2" label="Start Date" rules={[{ required: true, message: 'This field is required' }]}>
                                <DatePicker className="w-100" format="MM-DD-YYYY" onChange={onStartDateChange} />
                            </Form.Item>
                            <Form.Item name="endDate" className="col-md-2" label="End Date" rules={[{ required: true, message: 'This field is required' }]}>
                                <DatePicker className="w-100" format="MM-DD-YYYY" disabledDate={disablePastDates} />
                            </Form.Item>
                        </div>
                        <div className="row m-0">
                            <Form.Item name="appliedMode" className="col-md-2" label="Mode of applied" rules={[{ required: true, message: 'This field is required' }]}>
                                <Select className="w-100" options={modeOptions} />
                            </Form.Item>
                            <Form.Item
                                name="amount"
                                className="col-md-2"
                                label={location.state.type === '1' ? 'Fee per individual' : 'Total Amount'}
                                rules={[{ required: true, message: 'This field is required' }, { validator: validateAmount }]}
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item name="associateTrainer" className="col" label="Associate Trainer"
                                normalize={(value) =>
                                    value ? value.charAt(0).toUpperCase() + value.slice(1) : ''
                                }>
                                <Input />
                            </Form.Item>
                            <Form.Item name="status" className="col" label="Status" rules={[{ required: true, message: 'This field is required' }]}>
                                <Select options={statusOptions} />
                            </Form.Item>
                        </div>
                        <div className="row m-0">
                            <Form.Item name="associatedCandidates" className="col assoc-candid" label="Associate Candidates">
                                <Select
                                    options={location?.state?.type === '1' ? options : prjOptions}
                                    mode="multiple"
                                    filterOption={(input: any, option: any) => (option?.label ?? '')?.toLowerCase().includes(input.toLowerCase())}
                                    notFoundContent={
                                        <div className="text-center p-4">
                                            {loading3 || loading5 ? (
                                                <span>
                                                    <LoadingOutlined />
                                                    Loading...
                                                </span>
                                            ) : (
                                                <span>No candidates available</span>
                                            )}
                                        </div>
                                    }
                                />
                            </Form.Item>
                            <Form.Item name="description" className="col" label="Description" normalize={(value) =>
                                value ? value.charAt(0).toUpperCase() + value.slice(1) : ''
                            }>
                                <TextArea rows={2} />
                            </Form.Item>
                            <Form.Item name="feedback" className="col" label="Feedback" normalize={(value) =>
                                        value ? value.charAt(0).toUpperCase() + value.slice(1) : ''
                                    }>
                                <TextArea rows={2} />
                            </Form.Item>
                        </div>
                        <div className="text-end pe-2">
                            <Button type="primary" htmlType="submit" loading={loading1 || prjLoading}>
                                {location.state.id != 0 ? 'Update' : 'Add'}
                            </Button>
                        </div>
                    </Form>
                </div>
            </Spin>
        </div>
    );
};

export default AddBatch;
